export const CACHE_KEY_DECLINE_REQUEST_IN_ORDER = 'decline-request-in-order';
